import { defineMessages } from 'react-intl'

const scope = `procurify.components.AccountCodeSelect`

export default defineMessages({
  accountCodeSelectPlaceholder: {
    id: `${scope}.accountCodeSelectPlaceholder`,
    defaultMessage: 'Select an account code',
  },
  errorTitleText: {
    id: `${scope}.errorTitleText`,
    defaultMessage: 'Error',
  },
  errorMessageText: {
    id: `${scope}.errorMessageText`,
    defaultMessage: `An error has occured while retrieving account codes.`,
  },
})
